<template>
  <div class="top">
    <div class="left">
      <span class="banner">Project </span>
      <span class="project-id-span banner" @click="copyProjectId">
        {{ projectId }}
        <span class="tooltiptext">Copy Project Id to Clipboard</span>
      </span>
      <span class="banner"> : </span>
      <span class="project-name-span banner" @click="copyProjectName">
        {{ projectName }}
        <span class="tooltiptext">Copy Project Name to Clipboard</span>
      </span>
    </div>
    <div class="right">
      <h3>Owner : {{ owner }} Last Modified : {{ modified_on }}</h3>
    </div>
    <div class="button-div">
      <starButton :projectId="projectId"></starButton>
      <ProjectDeleteButton @clicked="confirmDelete"></ProjectDeleteButton>
    </div>
   </div>
  <Prompt :name="'project'" @confirmed="deleteProject" @cancelled="cancelDelete"></Prompt>
  <div class="debug">
    <p>debug project-header:</p>
    <p>projectId : {{ projectId }}</p>
    <p>projectName : {{ projectName }}</p>
    <p>owner : {{ owner }}</p>
    <p>modified_on : {{ modified_on }}</p>
  </div>
</template>

<script setup lang="ts">

import { useProjectStore, useAlertStore, useWatchlistStore, usePromptStore } from '@/stores' //TODO the router at /project/id should just get the project from the store and pass it down
import Prompt from '@/components/Prompt.vue'
import router from '@/router'
import starButton from '@/components/buttons/star-button.vue'
import ProjectDeleteButton from '@/components/buttons/project-delete-button.vue'

const watchlist = useWatchlistStore()
//const shortlist = useShortlistStore();
const projects = useProjectStore()
const prompt = usePromptStore()
const props = defineProps({
    projectId: { type: Number, required: true },
    projectName: { type: String, required: true},
    owner : { type: String, required: true },
    modified_on : { type: Date, required : false}
});

function cancelDelete(){
  console.log("project-header delete cancelled from prompt...");
}

/**
 * confirm and delete the project using the store
 */
async function confirmDelete() {
  console.log('project header confirm delete()...')
  prompt.promptUser({
    header: 'Delete Project?',
    body: 'This will permanently delete the project, associated invoices and postech components from the database.Google Drive folder and files will remain, but be orphaned.'
  })
}

/**
 * button click for deleting project 
 */
async function deleteProject() {
  prompt.close()
  console.log('confirmed delete of proj ' + JSON.stringify(props.projectName))
  const alert = useAlertStore()
  const id = props.projectId;
  let deleted
  try {
    deleted = await projects.deleteProject(id)
  } catch (error) {
    alert.error('error on project delete ' + error)
    console.error(error)
    return
  }
  if (deleted) {
    alert.success('Project ' + id + ' deleted')
    setTimeout(() => {
      alert.clear()
    }, 2000)

    //const watchlist = useWatchlistStore();
    //shortlist.remove(id)
    watchlist.remove(id)

    setTimeout(() => {
      // alert.clear();
      //projects.setCurrentProject(null);
      router.push('/projects')
      /*router.push({
                name: 'projects_list'
            });*/
    }, 2000)
  }
}

/**
 * copy the projectId to the clipboard
 */
function copyProjectId() {
  console.log('copy projectId clicked..')
  let copyText = props.projectId
  navigator.clipboard.writeText(copyText)
  console.log(copyText + ' copied to clipboard')
}

/**
 * copy the project name to the clipboard
 */
function copyProjectName() {
  console.log('copy projectName clicked..')
  let copyText = props.projectName
  navigator.clipboard.writeText(copyText)
  console.log(copyText + ' copied to clipboard')
}


</script>

<style lang="css" scoped>
.top {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  border: 2px solid var(--blue);
  /*border-radius: 5px;*/
  /* border-top-left-radius: 5px;
    border-top-right-radius: 5px;*/
  padding-left: 1rem;
  /*background-color: var(--light-grey);*/
}
button {
  font-size: 2rem;
  font-weight: bold;
  color: white;
  /* background-color: red;*/
  border: none;
}
div.button-div {
  display: flex;
}

span.project-id-span,
span.project-name-span {
  position: relative;
}

span.banner {
  font-size: x-large;
  font-weight: bolder;
}
.tooltiptext {
  visibility: hidden;
  width: 10rem;
  color: white;
  font-size: 0.875rem;
  text-align: center;
  padding: 5px 5px;
  border-radius: 6px;
  background-color: rgba(100, 100, 100, 0.6);

  /* Position the tooltip text - see examples below! */
  position: absolute;
  top: -3.5rem;
  left: -0rem;

  z-index: 1;
}

span.project-id-span:hover,
span.project-name-span:hover {
  cursor: pointer;
  /*border: 2px solid var(--blue);*/
  background-color: var(--blue);
  color: white;
}
span.project-id-span:hover .tooltiptext {
  visibility: visible;
}

span.project-name-span:hover .tooltiptext {
  visibility: visible;
}
</style>
